import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import { ReadyForOutboundTripDto, ReadyForOutboundTripQueryParams } from 'dtos/toDoLists/outboundTrips'
import { URIQuery } from 'utils'

const baseUrl = (): string => `/api/to-do-lists/outbound-trips/ready-for-outbound-trip`

export const getReadyForOutboundTripToDoList = (queryParams: ReadyForOutboundTripQueryParams) =>
  apiClient.get<ApiResponse<ReadyForOutboundTripDto[]>>(baseUrl() + URIQuery(queryParams)).then(res => res.data)
